WYATT.registerComponent(
  "recently-viewed",
  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      this.recents =
        JSON.parse(localStorage.getItem("wyattRecentlyViewed")) || [];
      this.currentlyViewedProduct =
        window.WYATT.shopify.product[this.dataset.recentlyViewed];

      this.removeCurrentlyViewedProductFromRecents();
      this.renderRecentlyViewed();
      this.addCurrentlyViewedProductToRecents();
    }

    removeCurrentlyViewedProductFromRecents() {
      if (!this.currentlyViewedProductInRecents()) {
        return;
      }

      this.recents = this.recents.filter(
        (product) => product.handle !== this.currentlyViewedProduct.handle
      );
    }

    addCurrentlyViewedProductToRecents() {
      if (this.currentlyViewedProductInRecents()) {
        return;
      }

      const product = {
        id: this.currentlyViewedProduct.id,
        handle: this.currentlyViewedProduct.handle,
        timestamp: Date.now(),
      };

      this.recents.unshift(product);
      localStorage.setItem("wyattRecentlyViewed", JSON.stringify(this.recents));
    }

    currentlyViewedProductInRecents() {
      return this.recents.some(
        (item) => item.id === this.currentlyViewedProduct?.id
      );
    }

    async getProductSummary(product) {
      const response = await fetch(
        `${WYATT.routes.root}products/${product.handle}?view=summary-vertical`
      );

      return response.text();
    }

    async renderRecentlyViewed() {
      if (this.recents.length === 0) {
        return;
      }

      const productSummaries = await Promise.all(
        this.recents.slice(0, 5).map(this.getProductSummary)
      );

      productSummaries.forEach(this.appendProductSummary.bind(this));

      this.showSection();
    }

    appendProductSummary(html) {
      const list = this.querySelector("[data-products]");
      const listItem = document.createElement("li");

      listItem.classList.add("product-grid__item");
      listItem.innerHTML = html;
      list.appendChild(listItem);
    }

    showSection() {
      this.closest(".recently-viewed").classList.remove("hidden");
    }
  }
);
